import { useQuery } from '@apollo/client';
import { isUserFDATier } from '../../shared/services/checkUserTierService';
import GET_ORG_UNITS_PERFORMANCE_REPORT from '../queries/getOrgUnitPerformanceReportQuery';
import GET_FDA_ORG_UNIT_PERFORMANCE_REPORT from '../queries/getFdaOrgUnitPerformanceReportQuery';

const usePerformanceOrgUnitQuery = (orgUnitId, tier) => {
  const { data, error, loading } = useQuery(
    isUserFDATier(tier) ? GET_FDA_ORG_UNIT_PERFORMANCE_REPORT : GET_ORG_UNITS_PERFORMANCE_REPORT,
    {
      variables: { id: orgUnitId }
    }
  );

  const getOrgUnitPerformanceData = () => {
    if (!data) {
      return;
    }

    return isUserFDATier(tier) ? data.fdaPerformanceOrgUnitReport : data.performanceOrgUnitReport;
  };

  return { orgUnitPerformanceData: getOrgUnitPerformanceData(), error, loading };
};

export default usePerformanceOrgUnitQuery;
